export function calculateStepSize(
  data: { [key: string]: number },
  numberOfSteps = 5
): number {
  const values = Object.values(data);
  const minVal = Math.min(...values);
  const maxVal = Math.max(...values);

  const diff = maxVal - minVal;

  // Calculate the step size based on the difference and the number of steps
  const stepSize = Math.ceil(diff / numberOfSteps);

  return stepSize;
}
